import { useEffect, useState } from 'react';
import { useNavigation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export function TopProgressBar() {
    const { state } = useNavigation();
    const [visible, setVisible] = useState(false);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (state === 'loading') {
            setVisible(true);
            setWidth(40);
            const t = setTimeout(() => setWidth(75), 300);
            return () => clearTimeout(t);
        } else {
            setWidth(100);
            const t = setTimeout(() => {
                setVisible(false);
                setWidth(0);
            }, 200);
            return () => clearTimeout(t);
        }
    }, [state]);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed top-0 left-0 right-0 z-[9998] h-0.5 bg-neutral-100 dark:bg-neutral-800"
                >
                    <div
                        className="h-full bg-brand-500 transition-all duration-300 ease-out rounded-r-full"
                        style={{ width: `${width}%` }}
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
}
